import { BillStatusEnum } from "@/features/billingBills/types/bills.type";
import { optionsToStrategy } from "../utils/optionsToStrategy";

export const billingBillStatus: { label: string; value: BillStatusEnum; }[] = [
  { label: 'Em processamento', value: BillStatusEnum.InProcess },
  { label: 'Aguardando pagamento', value: BillStatusEnum.PendingPayment },
  { label: 'Pago', value: BillStatusEnum.Paid },
  { label: 'Processando pagamento', value: BillStatusEnum.ProcessingPayment },
  { label: 'Parcialmente Pago', value: BillStatusEnum.PartiallyPaid },
  { label: 'Falha no SICOF', value: BillStatusEnum.WithIntegrationFailure },
  { label: 'Não requer pagamento', value: BillStatusEnum.PaymentNotNeeded },
  { label: 'Aguardando autorização de pagamento', value: BillStatusEnum.AwaitingPaymentConfirmation },
  { label: 'Aguardando autorização de fornecimento', value: BillStatusEnum.PendingSupplyAuthorization },
  { label: 'Aguardando aprovação manual', value: BillStatusEnum.AwaitingManualApproval },
  { label: 'Rejeitado pela empresa', value: BillStatusEnum.RejectedByCompany },
];

export const billingBillStatusStrategy = optionsToStrategy(billingBillStatus);
